import React from "react";
import "./Copyright.scss";

const Copyright = () => {
  return (
    <div className="copyright">
      <div className="copyright_info">
        <span>Copyright © Notions Group. All Rights Reserved.</span>
      </div>
    </div>
  );
};

export default Copyright;
